<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event type not found</h2>
</div>

<div class="pt-3" *ngIf="matrixNotFound">
  <h2>Pricing matrix not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && !matrixNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-3 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4" *ngIf="loadingEventType || loadingExistingMatrix">
      <h2>Loading...</h2>
    </div>

    <form class="m-4" *ngIf="!loadingEventType && !loadingExistingMatrix" (submit)="handleSubmit()">
      <div class="form-group row">
        <div class="col-lg-6 col-md-8">
          <label for="nameInput"><b>Pricing Matrix Name</b></label>
          <input id="nameInput" type="text" name="name"
                 class="form-control"
                 [(ngModel)]="matrix.name">
          <div class="form-text text-danger">{{ matrixErrors.name }}</div>
        </div>
      </div>

      <div class="mb-3">
        <label><b>Per-Participant Fees</b></label>

        <p *ngIf="matrix.per_participant_fees.length === 0" class="mb-2">
          <i>No Per-Participant Fees</i>
        </p>

        <table *ngIf="matrix.per_participant_fees.length > 0"
               class="table table-sm table-bordered col-md-11 col-lg-9 col-xl-7 mb-2 border-0">
          <tr *ngFor="let fee of matrix.per_participant_fees; let feeIdx = index;">
            <th>
              {{ fee.name }}
              <ng-container *ngIf="fee.includes_entry">
                <br>
                <span class="text-muted">Includes Entry</span>
              </ng-container>
              <ng-container *ngIf="fee.sell_voucher_via_pos">
                <br>
                <span class="text-muted">For Sale in POS</span>
              </ng-container>
            </th>
            <td>
              {{ orgConfig.getCurrencySymbol() }}{{ fee.fee }}
            </td>
            <td class="border-0 edit-and-remove-cell">
              <button type="button" class="btn btn-sm btn-outline-primary ml-1"
                      (click)="editPerParticipantFee(fee)">
                Edit
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                      (click)="matrix.per_participant_fees.splice(feeIdx, 1)">
                Remove
              </button>
            </td>
          </tr>
        </table>

        <button type="button" class="btn btn-sm btn-outline-primary"
                (click)="addPerParticipantFee()">
          Add Per-Participant Fee
        </button>

        <div class="form-text text-danger">{{ matrixErrors.per_participant_fees }}</div>
      </div>

      <div class="mb-3">
        <label><b>Per-Participant Add-Ons</b></label>

        <p *ngIf="matrix.per_participant_add_ons.length === 0" class="mb-2">
          <i>No Per-Participant Add-Ons</i>
        </p>

        <table *ngIf="matrix.per_participant_add_ons.length > 0"
               class="table table-sm table-bordered col-md-11 col-lg-9 col-xl-7 mb-2 border-0">
          <tr *ngFor="let addOn of matrix.per_participant_add_ons; let addOnIdx = index;">
            <th>
              {{ addOn.name }}
            </th>
            <td>
              {{ orgConfig.getCurrencySymbol() }}{{ addOn.fee }}
              <ng-container *ngIf="addOn.allow_multiple_copies">
                <br>
                <span class="text-muted">
                  Allows multiple copies (max {{ addOn.max_copies }},
                  via {{ addOn.multiple_copies_input_type === 'dropdown' ? 'dropdown' : 'number input' }})
                </span>
              </ng-container>
            </td>
            <td class="border-0 edit-and-remove-cell">
              <button type="button" class="btn btn-sm btn-outline-primary ml-1"
                      (click)="editPerParticipantAddOn(addOn)">
                Edit
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                      (click)="matrix.per_participant_add_ons.splice(addOnIdx, 1)">
                Remove
              </button>
            </td>
          </tr>
        </table>

        <button type="button" class="btn btn-sm btn-outline-primary"
                (click)="addPerParticipantAddOn()">
          Add Per-Participant Add-On
        </button>

        <div class="form-text text-danger">{{ matrixErrors.per_participant_add_ons }}</div>
      </div>

      <div class="mb-3">
        <label><b>Per-Booking Fees</b></label>

        <p *ngIf="matrix.per_booking_fees.length === 0" class="mb-2">
          <i>No Per-Booking Fees</i>
        </p>

        <table *ngIf="matrix.per_booking_fees.length > 0"
               class="table table-sm table-bordered col-md-11 col-lg-9 col-xl-7 mb-2 border-0">
          <tr *ngFor="let fee of matrix.per_booking_fees; let feeIdx = index;">
            <th>
              {{ fee.name }}
              <ng-container *ngIf="fee.includes_entry">
                <br>
                <span class="text-muted">Includes Entry</span>
              </ng-container>
              <ng-container *ngIf="fee.sell_voucher_via_pos">
                <br>
                <span class="text-muted">For Sale in POS</span>
              </ng-container>
            </th>
            <td>
              {{ orgConfig.getCurrencySymbol() }}{{ fee.fee }}
              <ng-container *ngIf="fee.included_participants">
                (Max {{ fee.included_participants }} Participants)
                <ng-container *ngIf="fee.additional_participant_fee">
                  <br>
                  {{ orgConfig.getCurrencySymbol() }}{{ fee.additional_participant_fee }} Per Additional Participant
                </ng-container>
              </ng-container>
            </td>
            <td class="border-0 edit-and-remove-cell">
              <button type="button" class="btn btn-sm btn-outline-primary ml-1"
                      (click)="editPerBookingFee(fee)">
                Edit
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                      (click)="matrix.per_booking_fees.splice(feeIdx, 1)">
                Remove
              </button>
            </td>
          </tr>
        </table>

        <button type="button" class="btn btn-sm btn-outline-primary"
                (click)="addPerBookingFee()">
          Add Per-Booking Fee
        </button>

        <div class="form-text text-danger">{{ matrixErrors.per_booking_fees }}</div>
      </div>

      <div class="mb-3">
        <label><b>Per-Booking Add-Ons</b></label>

        <p *ngIf="matrix.per_booking_add_ons.length === 0" class="mb-2">
          <i>No Per-Booking Add-Ons</i>
        </p>

        <table *ngIf="matrix.per_booking_add_ons.length > 0"
               class="table table-sm table-bordered col-md-11 col-lg-9 col-xl-7 mb-2 border-0">
          <tr *ngFor="let addOn of matrix.per_booking_add_ons; let addOnIdx = index;">
            <th>
              {{ addOn.name }}
            </th>
            <td>
              {{ orgConfig.getCurrencySymbol() }}{{ addOn.fee }}
              <ng-container *ngIf="addOn.included_participants">
                (Max {{ addOn.included_participants }} Participants)
                <ng-container *ngIf="addOn.additional_participant_fee">
                  <br>
                  {{ orgConfig.getCurrencySymbol() }}{{ addOn.additional_participant_fee }} Per Additional Participant
                </ng-container>
              </ng-container>
              <ng-container *ngIf="addOn.allow_multiple_copies">
                <br>
                <span class="text-muted">
                  Allows multiple copies (max {{ addOn.max_copies }},
                  via {{ addOn.multiple_copies_input_type === 'dropdown' ? 'dropdown' : 'number input' }})
                </span>
              </ng-container>
            </td>
            <td class="border-0 edit-and-remove-cell">
              <button type="button" class="btn btn-sm btn-outline-primary ml-1"
                      (click)="editPerBookingAddOn(addOn)">
                Edit
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger ml-1"
                      (click)="matrix.per_booking_add_ons.splice(addOnIdx, 1)">
                Remove
              </button>
            </td>
          </tr>
        </table>

        <button type="button" class="btn btn-sm btn-outline-primary"
                (click)="addPerBookingAddOn()">
          Add Per-Booking Add-On
        </button>

        <div class="form-text text-danger">{{ matrixErrors.per_booking_add_ons }}</div>
      </div>

      <div class="mb-3 row" *ngIf="showPerBookingDeposit">
        <div class="col-lg-6 col-md-8">
          <label for="perBookingDepositInput"><b>Per-Booking Deposit</b></label>
          <input type="number" class="form-control"
                 id="perBookingDepositInput" name="per_booking_deposit"
                 [(ngModel)]="matrix.per_booking_deposit">
          <small class="form-text text-muted">
            If a deposit amount is configured, it is due at the time a customer makes a booking, with the remaining fees payable later via the Climber App or Staff Site. If the total fees (the combined per-participant and per-booking fees) the customer owes are less than the deposit fee, then no deposit is collected, and the customer is instead charged the total fees at the time of booking.
          </small>

          <div class="alert alert-warning mt-2 mb-0" role="alert" *ngIf="showZeroDepositWarning">
            A Per-Booking Deposit of <b>0</b> means no payment is collected when a customer books: they can reserve without paying anything up front, and the entire balance becomes due later. To collect the full amount at the time of booking instead, leave this field blank rather than entering 0.
          </div>

          <div class="alert alert-info mt-2 mb-0" role="alert" *ngIf="showRequestFormDepositWarning">
            This event type is a private event request form, so the pricing matrix itself effectively acts as the deposit for the future private event. A separate Per-Booking Deposit is usually unnecessary here and can confuse customers. Unless you specifically want to collect only a partial payment at the time of the request, consider removing it by clearing this field.
          </div>
        </div>
      </div>

      <div class="mb-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="vouchersIncludeEntryInput" name="vouchers_include_entry"
                 [(ngModel)]="matrix.vouchers_include_entry">
          <label class="form-check-label" for="vouchersIncludeEntryInput">
            <b>Vouchers include entry</b>
          </label>
        </div>
        <small class="form-text text-muted">
          If this is checked, then customers who book using a voucher are granted entry to the gym.
        </small>
      </div>

      <div class="mb-3" *ngIf="eventType && (eventType.schedule_type === ScheduleType.oneOff)">
        <div class="form-check">
          <input class="form-check-input" type="checkbox"
                 id="allowCheckInBeforeFinalPaymentInput" name="allow_check_in_before_final_payment"
                 [(ngModel)]="matrix.allow_check_in_before_final_payment">
          <label class="form-check-label" for="allowCheckInBeforeFinalPaymentInput">
            <b>If this pricing matrix is used for a private event, allow customers to be checked into the event before the final payment is collected</b>
          </label>
        </div>
        <small class="form-text text-muted">
          If enabled, participants will be able to check into private events using this matrix, even if they are not fully paid. Enable this option for events where fees are collected after the event has begun.
        </small>
      </div>

      <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="mt-4">
        <div class="float-right">
          <button class="btn btn-primary" type="submit"
                  [disabled]="loadingSubmit" [class.disabled]="loadingSubmit">
            Save
          </button>
        </div>
        <button class="btn btn-secondary"
                [routerLink]="['/events/setup/edit/' + eventType?.id + '/pricing-matrices']"
                [disabled]="loadingSubmit" [class.disabled]="loadingSubmit">
          Back
        </button>
      </div>
    </form>

  </div>
</div>
